@for (column of gridColumns; track i; let i = $index) {
<div
  class="gridster-column"
  [ngStyle]="gridRenderer.getGridColumnStyle(i)"
></div>
} @for (row of gridRows; track i; let i = $index) {
<div class="gridster-row" [ngStyle]="gridRenderer.getGridRowStyle(i)"></div>
}
<ng-content></ng-content>
<gridster-preview
  [gridRenderer]="gridRenderer"
  [previewStyle$]="previewStyle$"
  class="gridster-preview"
></gridster-preview>
